import useSettingsParams from 'hooks/useSettingsParams';
import { useAuth } from 'context/AuthContext';
import { hidesPurchasePrices } from 'utils/helpers/access/hasUserAccess';

/** Видимість колонок звіту «Дохідність» з параметрів компанії */
const useReportObjectsColumns = () => {
    const params = useSettingsParams();
    const { auth } = useAuth();
    const hidePurchase = hidesPurchasePrices(auth?.user);
    const showMaterials = Boolean(params.reportObjectsShowMaterials) && !hidePurchase;
    const showServices = Boolean(params.reportObjectsShowServices) && !hidePurchase;
    const showOther = Boolean(params.reportObjectsShowOther) && !hidePurchase;

    return {
        showMaterials,
        showServices,
        showOther,
        colCount: 4 + (showMaterials ? 1 : 0) + (showServices ? 1 : 0) + (showOther ? 1 : 0),
    };
};

export default useReportObjectsColumns;
